import { MediaAddon, Spread } from 'editor/src/store/design/types';

const getAddonElementsUsedInSpread = (spread: Spread) =>
  (spread.pages[0].groups.media?.filter((el) => el.type === 'addon') as MediaAddon[]) || [];

export default getAddonElementsUsedInSpread;
